module.exports = __webpack_public_path__ + "img/trending-down.03de7fda.svg";